// extracted by mini-css-extract-plugin
export default {"icon":"IconBase_icon__gArIz","dirSensitive":"IconBase_dirSensitive__27BXd"};